// extracted by mini-css-extract-plugin
module.exports = {"superTable":"_3eMr-erWGkrF7HCaAPn2no","tableContainer":"_2ynjDjk8JPAtpXO5l1A5tt"};